export const csvImportActions = {
  csvImportLoading: "CSV_IMPORT_LOADING",
  csvImportReady: "CSV_IMPORT_READY"
};
